import { Action, popupState } from "../../types"

export const initialPopupState:popupState = {
    type:"Alert",
    message:"",
    isOpen:false,
    callBack:()=>{}
}
export function genericPopupReducer(state:popupState=initialPopupState,action:Action<popupState>):popupState{
    switch(action.type){
        case "setPopupState":
            return {...state,...action.payload};
        case "closePopup":
            return {...initialPopupState, type:state.type}
    }
    return state
}